import {IDocument, IFile} from "@/store/step3";

export function isDopDoc(doc: IDocument): boolean {
    return !doc.files.length && !!doc.requirements.length;
}

export function isRequirementFile(doc: IDocument): boolean {
    return doc.files.some(file => isRequirementUpload(file));
}

export function isRequirementUpload(file: IFile): boolean {
    return Boolean(file.requirement) && !Boolean(file.requirement?.completed) && file.lkbExists;
}

export const getFileType = (file: IFile): string =>  file.name.toLowerCase().split('.').pop() || '';
